import { format } from 'date-fns'

const ACCESS_DATE_TIME_PATTERN = 'P HH:mm'

export const formatAccessDateTime = (value: string) =>
  format(new Date(value), ACCESS_DATE_TIME_PATTERN)
